module.exports = __webpack_public_path__ + "static/media/cat3.a6e1596e.jpeg";